import React from 'react'
import {
  SingleSelectComboboxProps,
  SingleSelectCombobox
} from './single-select-combobox'

export function SingleSelectComboboxObject<T extends object>(
  props: SingleSelectComboboxProps<T> & {
    readonly itemToString: (item: T) => string
  }
) {
  return <SingleSelectCombobox<T> {...props} />
}
